import React from 'react';
import TabukComprehensiveDashboard from './TabukComprehensiveDashboard';

function App() {
  return (
    <div className="App">
      <TabukComprehensiveDashboard />
    </div>
  );
}

export default App;